// import useAxios, { Options, UseAxiosResult, ResponseValues } from "axios-hooks";
import * as config  from "../config";
import useSessionStorage from "@/hooks/useSessionStorage";
import useAuth from "@/hooks/useAuth";
import useAxiosWLS from "@/hooks/useAxiosWLS";
import { AuthUser } from "@/types/auth";

// export const useUsers = (url: string, options = {})=>{
//     return useAxios(`${config.apiConfig.host}/admin/users`, options)
// }

interface AuthenticationAttempt {
    id: string
    email: string
    ipAddress: string
    success: boolean
    userId: string
    firstName: string
    lastName: string
    user?: {
        id: string
        email: string
        isLocked: boolean
        isActive: boolean
        isReady: boolean
    },
    locations?: {
        country: string
        city: string
        latitude: number
        longitude: number
    }[],
    createdAt: string
    updatedAt: string
}

export const useAuthenticationsRequest = (user: AuthUser) => {
    const token = user?.token

    const url = token ? `${config.apiConfig.host}/admin/users/authentications` : undefined;
    const headers = {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`,
    }

    return useAxiosWLS<AuthenticationAttempt[]>({
        url,
        options: {
            headers
        }
    })
}

export const useAuthenticationsForEmailRequest = (user: AuthUser, {email}:{email?: string}) => {
    const token = user?.token

    const url = (token && email) ? `${config.apiConfig.host}/admin/users/authentications/?email=${email}` : undefined;
    const headers = {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`,
    }
    return useAxiosWLS<AuthenticationAttempt[]>({
        url,
        options: {
            headers
        }
    })
}